import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const Icon = ({ className, name, faded, size, ...props }) => {
    const [fill, setFill] = useState('transparent');
    const iconRef = useRef(null);

    // match svg colors
    useEffect(() => {
        if (name === 'script' && iconRef.current) {
            const iconStyles = window.getComputedStyle(iconRef.current);
            setFill(iconStyles.getPropertyValue('color'));
        }
    }, [name]);

    return (
        <span
            className={`Icon ${className} ${faded ? 'Icon--faded' : ''} Icon--${size}`}
            aria-hidden='true'
            ref={iconRef}
            {...props}
        >
            {name === 'script' ? (
                <Script fill={fill} />
            ) : cleanBuggyNames(name)}
        </span>
    );
};

export default Icon;

Icon.propTypes = {
    // className to pass onto tags
    className: PropTypes.string,

    // name of the icon
    name: PropTypes.string,

    // whether or not the icon is faded
    faded: PropTypes.bool,

    // size of the icon
    size: PropTypes.oneOf(['small', 'medium', 'large'])
};

Icon.defaultProps = {
    className: '',
    faded: false,
    size: 'medium'
};

const Script = ({ fill }) => (
    <svg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <g id='Artboard' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <path d='M20.5317173,1.15413139 L20.576962,1.29827148 L21.0297217,2.98799374 C21.2666133,3.87208538 20.7846016,4.77883724 19.9427276,5.08364421 L19.7991448,5.1287647 L5.362,8.997 L20.258582,8.99722345 C21.1729349,8.99722345 21.9228205,9.70406269 21.9955232,10.6030805 L22.0013003,10.7465527 L22.0013003,21.242528 C22.0013003,22.1603494 21.2971323,22.9130797 20.401512,22.9860582 L20.258582,22.9918572 L4.57411705,22.9918572 C3.65976414,22.9918572 2.90987848,22.2850179 2.83717579,21.3860002 L2.83139873,21.242528 L2.83139873,10.7465527 C2.83139873,10.0710889 3.21278405,9.48504041 3.77118891,9.19354812 C3.22839937,9.055569 2.76629755,8.65811499 2.56216276,8.10435319 L2.51301871,7.94952936 L2.06025899,6.25980709 C1.82336735,5.37571545 2.30537906,4.46896359 3.14725308,4.16415663 L3.29083591,4.11903613 L18.4408656,0.0595979028 C19.3216162,-0.1763985 20.2263138,0.308913789 20.5317173,1.15413139 Z M19.4290251,10.7465527 L5.44271067,10.7465527 C4.90819152,10.7465527 4.62037352,10.9811801 4.57925666,11.4504349 L4.57411705,11.5726367 L4.57411705,20.4007487 C4.57411705,20.9187667 4.8208182,21.1976995 5.31422049,21.237547 L5.44271067,21.242528 L19.4290251,21.242528 C19.9395216,21.242528 20.2144044,21.0047164 20.2536733,20.5290932 L20.258582,20.4052331 L20.258582,11.5726367 C20.258582,11.021914 19.982063,10.7465527 19.4290251,10.7465527 Z M4.58259263,5.58394983 C4.06628678,5.72229356 3.84900198,6.02341902 3.93073823,6.48732618 L3.95740189,6.60669426 L3.97848684,6.68538433 C4.11255976,7.18575131 4.42304788,7.39132872 4.9099512,7.30211658 L5.03535235,7.2736721 L7.033,6.738 L7.30260321,4.85512519 C5.71429863,5.28071012 4.80762843,5.52365167 4.58259263,5.58394983 Z M9.5477012,4.253553 L9.277,6.136 L13.411,5.029 L13.68032,3.14622112 C12.097505,3.57033512 10.7199654,3.93944574 9.5477012,4.253553 Z M18.0923349,1.96402529 C17.3384107,2.16603867 16.6159121,2.35963161 15.9248389,2.54480411 L15.655,4.427 L18.5450946,3.65374756 C19.0381964,3.52162133 19.2421626,3.2207681 19.1569932,2.75118787 L19.1296772,2.63027767 L19.1074316,2.54725603 C18.9648941,2.01529879 18.6265285,1.82088854 18.0923349,1.96402529 Z' id='Combined-Shape' fill={fill} fillRule='nonzero' />
        </g>
    </svg>
);

Script.propTypes = {
    fill: PropTypes.string
};

const cleanBuggyNames = (name) => {
    switch (name) {
    case 'trash-can':
        return '';
    case 'arrow-std-left':
        return '';
    case 'map-a':
        return '';
    case 'ellipse-b':
        return '';
    case 'area-graph':
        return '';
    case 'small-caret-down':
        return '';
    case 'small-caret-up':
        return '';
    default:
        return name;
    }
};
